import { EmailCommand } from "commands/EmailCommand";
import { AcceptInvitationCommand } from "commands/users/AcceptInvitationCommand";
import { ChangePasswordCommand } from "commands/account/ChangePasswordCommand";
import { EmailLoginCommand } from "commands/account/EmailLoginCommand";
import { RecoverPasswordCommand } from "commands/account/RecoverPasswordCommand";
import { SuccessResult } from "results/SuccessResult";
import { GetInvitationResult } from "results/users/GetInvitationResult";
import { GlobalDataResult } from "results/account/GlobalDataResult";
import { useApiService } from "services/ApiService";
import { SchoolLoginResult } from "results/account/SchoolLoginResult";
import { AcceptInvitationResult } from "results/account/AcceptInvitationResult";
import { RecoverPasswordResult } from "results/account/RecoverPasswordResult";
import { CodeCommand } from "commands/CodeCommand";
import { TeacherLoginMethodResult } from "results/account/TeacherLoginMethodResult";
import { NswCompleteCommand } from "commands/account/NswCompleteCommand";
import { NswCompleteResult } from "results/account/NswCompleteResult";

export const AccountApiService = () => {
    const { get, post } = useApiService({ controller: "/account" });

    const getNswChallengeUrl = (props?: { returnUrl?: string; description?: string }) => {
        const search = new URLSearchParams();

        if (props?.returnUrl) {
            search.set("returnUrl", props.returnUrl);
        }

        if (props?.description) {
            search.set("description", props.description);
        }

        return `/api/account/nsw/challenge?${search.toString()}`;
    };

    return {
        loginMethod: (email: string) =>
            get<TeacherLoginMethodResult>(`/login-method?email=${encodeURIComponent(email)}`),
        loginEmail: (command: EmailLoginCommand) => post<SchoolLoginResult>("/login-email", command),
        loginGoogle: (command: CodeCommand) => post<SchoolLoginResult>("/login-google", command),
        changePassword: (command: ChangePasswordCommand) => post<SuccessResult>("/change-password", command),
        forgotPassword: (command: EmailCommand) => post<SuccessResult>("/forgot-password", command),
        getRecoverPassword: (hash: string) => get<SuccessResult>(`/recover-password/${hash}`),
        recoverPassword: (command: RecoverPasswordCommand) => post<RecoverPasswordResult>("/recover-password", command),
        getInvitation: (hash: string) => get<GetInvitationResult>(`/invitation/${hash}`),
        getGlobalUserData: () => get<GlobalDataResult>("/global-data"),
        acceptInvitation: (command: AcceptInvitationCommand) =>
            post<AcceptInvitationResult>("/accept-invitation", command),
        nswComplete: (command: NswCompleteCommand) => post<NswCompleteResult>("/nsw/complete", command),
        getNswChallengeUrl,
    };
};
